export const containerStyles = {
  display: 'flex',
  alignItems: 'center',
};

const commonButtonStyles = {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
    opacity: 0.8,
    backgroundColor: ({ palette }) => `${palette.primary.main} !important`,
  },
};

export const buttonStyles = {
  lineHeight: '1.4rem',
  fontSize: '1.2rem',
  padding: '8px 9px 8px 16px',
  fontWeight: 400,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  borderRadius: '8px 0 0 8px',
  marginRight: '-1px',
  ...commonButtonStyles,
};

export const iconButtonStyles = {
  padding: '8px 16px 8px 8px',
  borderRadius: '0 8px 8px 0',
  minWidth: '40px',
  ...commonButtonStyles,
};

export const controlButtonStyles = {
  lineHeight: '1.6rem',
  fontSize: '1.4rem',
  padding: '8px 16px',
  fontWeight: 400,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  width: '100%',
  color: ({ palette }) => palette.text.primary,
  justifyContent: 'flex-start',
  '&:hover': {
    backgroundColor: ({ palette }) => `${palette.background.secondary} !important`,
  },
};

export const controlsStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const getPopoverStyles = ({ isView }) => ({
  '.MuiPaper-root': {
    borderRadius: '8px',
    minWidth: isView ? '134px' : '186px',
    top: '213px !important',
    boxShadow: '0px 5px 12px 4px #0000000D',
    padding: '4px 0',
  },
});

export const permissionMessageStyles = {
  maxWidth: '320px',
  padding: '4px 16px 8px',
};
